import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-blank',[_vm._t("default"),_c(VSnackbar,{attrs:{"timeout":2500,"value":!!_vm.snackbar.message,"right":"","top":"","color":_vm.snackbar.type},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c(VBtn,_vm._b({attrs:{"color":"white","icon":""},on:{"click":function($event){return _vm.$store.commit('RESET_ALERT')}}},'v-btn',attrs,false),[_c(VIcon,[_vm._v("mdi-close")])],1)]}}])},[_vm._v(" "+_vm._s(_vm.snackbar.message)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }